<div class="columns">
  <div class="column">
    <app-header
      header="kwh.title"
      subHeader="kwh.subtitle"
      class="mb-5"
    ></app-header>
  </div>
  @if (isAtruvia) {
    <div
      class="column is-flex is-justify-content-flex-end is-align-items-center activate-switch"
    >
      <app-activate-product-switch
        [isActive]="isActive"
        (onActiveChanged)="toggleActiveState($event)"
      ></app-activate-product-switch>
    </div>
  }
</div>
@if (!isActive) {
  <div class="mb-4 mx-2">
    <app-action-box
      class="mb-4"
      header="serviceDisabled.title"
      subHeader="kwh.disabled.subtitle"
      icon="Earth Remove"
      iconClass="tile-icon has-text-danger has-background-danger-light"
      isNotClickable
      [isFullheight]="false"
      hideCtaButton
    ></app-action-box>
  </div>
}

<div class="dynamic-grid">
  @if (showArchiving) {
    <div class="grid-item" huge>
      <app-action-box
        class="is-fullwidth mx-2"
        header="kwh.actions.archiving.title"
        subHeader="kwh.actions.archiving.subtitle"
        icon="Archive Locker 1"
        isNotClickable
        hideCtaButton
        [active]="isArchivingActive"
      >
        <div class="is-flex is-justify-content-center is-fullheight">
          <app-archiving
            #archiving
            class="is-fullwidth"
            [archivingSettings]="
              $safeNavigationMigration(kwhSettings?.archiving)
            "
            (archivingChanged)="archivingChanged($event)"
          ></app-archiving>
        </div>
      </app-action-box>
    </div>
  }

  <div class="grid-item" medium>
    <app-action-box
      class="is-fullwidth mx-2"
      header="overview.basicInfo.info.title"
      subHeader="overview.basicInfo.info.subtitle"
      iconSrc="/assets/icons/icon-info.svg"
      iconClass="p-4"
      isNotClickable
      hideCtaButton
    >
      <app-kwh-basic-infos [kwhSettings]="kwhSettings"></app-kwh-basic-infos>
    </app-action-box>
  </div>

  <div class="grid-item" short>
    <app-action-box
      class="is-fullwidth mx-2"
      (click)="openDeadlinesModal()"
      header="kwh.actions.mahnversand.title"
      subHeader="kwh.actions.mahnversand.subtitle"
      icon="Common File Text Warning"
    ></app-action-box>
  </div>

  @if (showAutoApplyStandingOrders) {
    <div class="grid-item" short>
      <app-action-box
        class="is-fullwidth mx-2"
        (click)="toggleStandingOrdersSettings()"
        [active]="featureAutoApplyStandingOrders"
        [isLoading]="!toggleAutoApplyStandingOrdersSubscription.closed"
        header="kwh.actions.autoApplyStandingOrders.title"
        [ctaLabel]="
          'kwh.actions.autoApplyStandingOrders.' +
          (featureAutoApplyStandingOrders ? 'deactivate' : 'activate')
        "
        subHeader="kwh.actions.autoApplyStandingOrders.subtitle"
        icon="Calendar 1"
      ></app-action-box>
    </div>
  }

  <div class="grid-item" short>
    <app-action-box
      class="is-fullwidth mx-2"
      (click)="openKWHUserAdministration()"
      header="kwh.actions.admins.title"
      subHeader="kwh.actions.admins.subtitle"
      icon="Single Neutral Actions Setting"
      ctaLabel="kwh.actions.admins.cta"
    ></app-action-box>
  </div>

  <div class="grid-item" short>
    <app-action-box
      class="is-fullwidth mx-2"
      (click)="openFomEmailModal()"
      header="kwh.actions.fomEmail.title"
      subHeader="kwh.actions.fomEmail.subtitle"
      icon="Alarm Bell 1"
    ></app-action-box>
  </div>

  @if (isAtruvia) {
    <div class="grid-item" short>
      <app-action-box
        class="is-fullwidth mx-2"
        (click)="toggleStammdatenSettings()"
        [active]="featureStammdatenweitergabe"
        [isLoading]="!toggleStammdatenSubscription.closed"
        header="kwh.actions.stammdaten.title"
        [ctaLabel]="
          'kwh.actions.stammdaten.' +
          (featureStammdatenweitergabe ? 'deactivate' : 'activate')
        "
        subHeader="kwh.actions.stammdaten.subtitle"
        icon="Single Neutral Actions Question"
      ></app-action-box>
    </div>
  }

  <div class="grid-item" short>
    <app-action-box
      class="is-fullwidth mx-2"
      header="kwh.actions.letterTemplate.title"
      subHeader="kwh.actions.letterTemplate.subtitle"
      icon="Read Email Letter"
      isNotClickable
      hideCtaButton
    >
      <div class="is-flex is-justify-content-center">
        <div class="is-flex">
          <button
            type="button"
            (click)="openLetterTemplateModal()"
            class="mr-1"
            fino-button
            primary
            translate
          >
            kwh.actions.letterTemplate.settings
          </button>
          <button
            type="button"
            (click)="openLetterUploadModal()"
            fino-button
            class="ml-1"
            primary
            translate
          >
            kwh.actions.letterTemplate.pdf
          </button>
        </div>
      </div>
    </app-action-box>
  </div>
</div>
